import { BooleanLiteral } from 'typescript';

export class FormTransaction {
  id: number;
  formId: number;
  formData: string;
  status: number;
  memberId: number;
  memberName: string;
  userId: string;
  createdBy: string;
  creationDate: Date;
}
